// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import { chain, ExecuteOnSuccessCallback } from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";

/* <XNG-Change HSP-842> to handle the case of bad data where we request for example 10 products and receive less than 10 
    products in response, we are mapping the original 10 products and making a custom obj with the flag 
    noInventoryFound, this flag will trigger the inventory error message  */
export const XngCheckForMissingData = (props: any) => {
    if (!props.error && props.apiResult.realTimeInventoryResults) {
        props.apiResult.realTimeInventoryResults = props.parameter.productIds.map((o:any) =>{
            return props.apiResult.realTimeInventoryResults?.find((i:any)=>i.productId === o) || 
            { productId: o, additionalResults: {noInventoryFound: true} as any} as any});
    }
};

addToChainBefore(chain, ExecuteOnSuccessCallback, XngCheckForMissingData);
